import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  displayText?: string
  toolTip?: string
  className?: string
}

export const AncientFormWrapHorizontal: React.FC<Props> = ({
  displayText,
  toolTip,
  children,
  className,
}) => {
  return (
    <>
      {displayText != undefined && displayText != '' ? (
        <div className={`mb-6 ${className}`}>
          <OverlayTrigger
            placement='top'
            delay={{show: 250, hide: 400}}
            overlay={toolTip ? <Tooltip>{toolTip}</Tooltip> : <></>}
          >
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>{displayText}</label>
          </OverlayTrigger>
          <div className='col-lg-8'>
            <div className='row'>
              <div className='col-lg-12 fv-row'>{children}</div>
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  )
}
